<ngx-simplebar class="px-3 mx-n3 mb-2" style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
  [options]="{ forceVisible: true }">
  <div class="card mt-n3">
    <div class="card-header">
      <div class="row g-2">
        <div class="col-12">
          <div class="list-grid-nav hstack gap-1" ngbDropdown>
            <div class="d-flex justify-content-between align-items-center w-100 mx-auto" style="max-width: 100%;">
              <ul ngbNav #navContactsp="ngbNav" [(activeId)]="nabTabActive" (activeIdChange)="activeIdChangeNabTab()"
                class="d-flex gap-1 mb-0">
                <li [ngbNavItem]="1">
                  <a ngbNavLink class="nav-link btn btn-soft-primary btn-label waves-effect waves-light py-1">
                    <i class="ri-list-unordered label-icon align-middle me-2"></i>
                    {{'t-owners' | translate}}
                  </a>

                  <ng-template ngbNavContent>
                    <app-contacts-list [requiredOwner]="requiredOwner" [propertyContactsData]="contactsData" [property]="property"
                      [loginUser]="loginUser">
                    </app-contacts-list>
                  </ng-template>
                  <!--end row-->
                </li>

                <li [ngbNavItem]="2">
                  <a ngbNavLink class="nav-link btn btn-soft-primary btn-label waves-effect waves-light btn py-1">
                    <i class="ri-list-unordered label-icon align-middle fs-16 me-2"></i>

                    {{'t-costumers' | translate}}
                  </a>

                  <ng-template ngbNavContent>
                    <app-contacts-list [propertyContactsData]="contactsData" [property]="property"
                      [loginUser]="loginUser">
                    </app-contacts-list>
                    <!--end row-->
                  </ng-template>
                </li>
              </ul>

              <button class="btn btn-outline-primary waves-effect waves-primary py-1" id="create-btn"
                (click)="openModal()" [class.placeholder]="hideElement" [attr.disabled]="hideElement ? true: null"
                *ngIf="permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') 
                || permissionsService.canEditProperty(loginUser, property?.store?.id) || !property">
                <i class="ri-add-line align-bottom me-1"></i>

                {{ textAddContact | translate}}
              </button>
            </div>
          </div>
        </div>
        <!--end col-->
      </div>
      <!--end row-->
    </div>

    <div class="card-body">
      <div class="row align-items-center">
        <div class="col">
          <div class="tab-content text-muted">
            <div [ngbNavOutlet]="navContactsp"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ngx-simplebar>

<app-contacts-create-edit></app-contacts-create-edit>